import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import AdsDialog from './AdsDialog';
import AdsButton from './AdsButton';

const CONFIRM_VARIANT = {
  warning: 'warning',
  danger: 'danger',
  info: 'info',
};

/**
 * ADS Confirm Dialog — warning / danger / info confirmation (Phase 3).
 */
const AdsConfirmDialog = ({
  isOpen,
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  type = 'warning',
}) => {
  const { t } = useLanguage();
  const tc = (key) => t(`confirmDialog.${key}`);
  const dialogType = CONFIRM_VARIANT[type] || CONFIRM_VARIANT.warning;
  const visible = isOpen ?? open;

  const handleConfirm = () => {
    onConfirm?.();
    onClose?.();
  };

  const confirmVariant = dialogType === 'danger' ? 'danger' : 'primary';

  return (
    <AdsDialog
      open={visible}
      onClose={onClose}
      title={title || tc('defaultTitle')}
      compact
      layer="confirm"
      className="ads-confirm-dialog"
      headerType={dialogType}
      icon={
        <AlertTriangle
          size={22}
          strokeWidth={1.5}
          className={`ads-dialog__icon--${dialogType}`}
          aria-hidden
        />
      }
      footer={
        <>
          <AdsButton variant="secondary" onClick={onClose}>
            {cancelText || tc('cancel')}
          </AdsButton>
          <AdsButton variant={confirmVariant} onClick={handleConfirm}>
            {confirmText || tc('confirm')}
          </AdsButton>
        </>
      }
    >
      <p className="ads-dialog__message">{message || tc('defaultMessage')}</p>
    </AdsDialog>
  );
};

export default AdsConfirmDialog;
